import React from "react";
import {observer} from "mobx-react";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";

interface UserMenuItemsContainerComponentProps extends ComponentServicesPick<'userMenu'> {
}


const ComponentBody: React.FC<UserMenuItemsContainerComponentProps> = observer((props) => {

  const menuItems = props.userMenu.userMenuItems;

  return (
      <>
        {menuItems.map(menuItem => <React.Fragment key={menuItem.key}>{menuItem.renderMenuItem()}</React.Fragment>)}
      </>
  );
});

export const UserMenuItemsContainerComponent = withServices(ComponentBody, ["userMenu"]);